import React from "react";

function Config() {
  return <></>;
}

//
// apiKey: "AIzaSyCmkdV0Vc9aSBbhIjArrcWkUM3JkFw2hes",
// authDomain: "react-login-register-ui-7386d.firebaseapp.com",
// projectId: "react-login-register-ui-7386d",
// storageBucket: "react-login-register-ui-7386d.appspot.com",
// messagingSenderId: "963524762079",
// appId: "1:963524762079:web:3d021fd2ce0fc569098c6a",
//

export const API_KEY = "AIzaSyCmkdV0Vc9aSBbhIjArrcWkUM3JkFw2hes";
export const AUTH_DOMAIN = "react-login-register-ui-7386d.firebaseapp.com";
export const PROJECT_ID = "react-login-register-ui-7386d";
export const STORAGE_BUCKET = "react-login-register-ui-7386d.appspot.com";
export const MESSAGING_SENDER_ID = "963524762079";
export const APP_ID = "1:963524762079:web:3d021fd2ce0fc569098c6a";

export default Config;
